


























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import "./scss";

@Component({})
export default class ItemSection extends Vue {
  @Prop(String) title!: string;
  @Prop(Boolean) collapsible!: boolean;
  @Prop({ type: Boolean, default: true }) showFooter!: boolean;
  @Prop({ type: Boolean, default: true }) hasHeader!: boolean;
  @Prop({ type: Boolean, default: false }) open!: boolean;
  @Prop(Number) itemIndex!: boolean;
  @Prop({ type: Boolean, default: true }) growRightColumn!: boolean;
  @Prop({ type: Boolean, default: true }) growLeftColumn!: boolean;
  @Prop() summary!: string;

  open_: boolean = this.collapsible ? this.open : true;

  @Watch("open")
  onPropertyChanged(open: boolean) {
    this.open_ = open;
  }

  get sectionClasses() {
    return this.open_ ? [] : "closed";
  }

  get hasLeftSlot() {
    const hasLeftSlot = !!(this.$slots.left || [])[0];

    return hasLeftSlot;
  }

  get hasRightSlot() {
    const hasRightSlot = !!(this.$slots.right || [])[0];

    return hasRightSlot;
  }

  created() {
    if (this.collapsible) {
      this.open_ = this.open;
    }
  }

  onClick() {
    if (this.collapsible) {
      this.open_ = !this.open_;
    }
  }
}
